import axios from 'axios';
import { History } from 'history';

const api_url = process.env.REACT_APP_API_URL;


export const getJobs = async (query: string = '') => {
  return await axios.get(process.env.REACT_APP_API_URL + 'jobs/' + query);
};

export const getJob = async (jobId: string, history?: History) => {
  return await axios
    .get(process.env.REACT_APP_API_URL + `jobs/${jobId}/`)
    .then((res) => res)
    .catch((e) => {
      if (e?.response?.data?.error_code === 'resource_not_found' && history)
        history.push('/not-found');
      return e.response;
    });
};

export const getPublicJob = async (jobId: string, history?: History, inviteToken?: string) => {
  const url = `${process.env.REACT_APP_API_URL}public/jobs/${jobId}/`;
  const urlWithToken = inviteToken ? `${url}?invite_token=${inviteToken}` : url;

  return await axios
    .get(urlWithToken)
    .then((res) => res)
    .catch((e) => {
      if (e?.response?.data?.error_code === 'resource_not_found' && history)
        history.push('/not-found');
      return e.response;
    });
};

export const createJob = async (company: string, department: string) => {
  return await axios.post(process.env.REACT_APP_API_URL + 'jobs/', {
    company,
    department,
  });
};

export const updateJobFlexibleFee = async ({
  jobId,
  payload,
}: {
  jobId: string;
  payload: any;
}) => {
  return await axios.patch(
    process.env.REACT_APP_API_URL + `jobs/${jobId}/`,
    payload,
  );
};

export const getJobInfo = async (jobId: string) => {
  return await axios
    .get(process.env.REACT_APP_API_URL + `jobs/${jobId}/details/info/`)
    .then((res) => res)
    .catch((e) => {
      return e.response;
    });
};

export const updateJobInfo = async (jobId: string, draft: any) => {
  return await axios
    .put(process.env.REACT_APP_API_URL + `jobs/${jobId}/details/info/`, {
      ...draft,
    })
    .then((res) => res);
};

export const getJobCandidateProfile = async (jobId: string) => {
  return await axios
    .get(
      process.env.REACT_APP_API_URL +
      `jobs/${jobId}/details/candidate-profile/`,
    )
    .then((res) => res)
    .catch((e) => {
      return e.response;
    });
};

export const updateJobCandidateProfile = async (jobId: string, draft: any) => {
  return await axios.put(
    process.env.REACT_APP_API_URL + `jobs/${jobId}/details/candidate-profile/`,
    {
      ...draft,
    },
  );
};

export const getJobOffer = async (jobId: string) => {
  return await axios
    .get(process.env.REACT_APP_API_URL + `jobs/${jobId}/details/offer/`)
    .then((res) => res)
    .catch((e) => {
      return e.response;
    });
};

export const updateJobOffer = async (jobId: string, draft: any) => {
  return await axios.put(
    process.env.REACT_APP_API_URL + `jobs/${jobId}/details/offer/`,
    {
      ...draft,
    },
  );
};

export const getJobTeamInfo = async (jobId: string) => {
  return await axios
    .get(process.env.REACT_APP_API_URL + `jobs/${jobId}/details/team-info/`)
    .then((res) => res)
    .catch((e) => {
      return e.response;
    });
};

export const updateJobTeamInfo = async (jobId: string, draft: any) => {
  return await axios.put(
    process.env.REACT_APP_API_URL + `jobs/${jobId}/details/team-info/`,
    {
      ...draft,
    },
  );
};

export const getJobInterviewProcess = async (jobId: string) => {
  return await axios
    .get(
      process.env.REACT_APP_API_URL +
      `jobs/${jobId}/details/interview-process/`,
    )
    .then((res) => res)
    .catch((e) => {
      return e.response;
    });
};

export const updateJobInterviewProcess = async (jobId: string, draft: any) => {
  return await axios.patch(
    process.env.REACT_APP_API_URL + `jobs/${jobId}/details/interview-process/`,
    {
      ...draft,
    },
  );
};

export const createSimpleJob = async (draft: any, isDraft: boolean = false) => {
  if (isDraft) {
    draft.status = 'draft';
  }
  return await axios.post(process.env.REACT_APP_API_URL + `public/jobs/`, {
    ...draft,
  });
};

export const unpublishJob = async (jobId: string, reason: string) => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}jobs/${jobId}/unpublish/`,
    {
      unpublished_reason: reason,
    },
  );
};

export const onholdJob = async (jobId: string, reason: string) => {
  return axios.post(`${process.env.REACT_APP_API_URL}jobs/${jobId}/onhold/`, {
    unpublished_reason: reason,
  });
};

export const publishJob = async (jobId: string) => {
  return axios.post(`${process.env.REACT_APP_API_URL}jobs/${jobId}/publish/`);
};

export const deleteJob = async (jobId: string) => {
  return axios.delete(`${process.env.REACT_APP_API_URL}jobs/${jobId}/`);
};

export const getJobsByFilter = async (filter: string, query: string = '') => {
  const url = filter
    ? `${process.env.REACT_APP_API_URL}jobs/` + filter + '/' + query
    : `${process.env.REACT_APP_API_URL}jobs/${query}`;
  return axios.get(url);
};

export const addToFavorites = async (jobId: string) => {
  return axios.post(`${process.env.REACT_APP_API_URL}jobs/${jobId}/favorites/`);
};

export const removeFromFavorites = async (jobId: string) => {
  return axios.delete(
    `${process.env.REACT_APP_API_URL}jobs/${jobId}/favorites/`,
  );
};

export const getSimilarJobs = async (jobId: string) => {
  return await axios
    .get(process.env.REACT_APP_API_URL + `jobs/${jobId}/similar/`)
    .then((res) => res)
    .catch((e) => {
      return e.response;
    });
};

export const getJobPdf = async (jobId: string) => {
  return await axios
    .get(process.env.REACT_APP_API_URL + `jobs/${jobId}/export/pdf/`, {
      headers: { 'Content-Type': 'application/pdf' },
      responseType: 'arraybuffer',
    })
    .then((res) => new Blob([res.data]))
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      // the filename you want
      a.download = 'job.pdf';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch((e) => {
      return e.response;
    });
};

//Send a log to the JobEvents in SalesForce
export const sendJobPdfLog = async (jobId: string) =>
  axios.post(`${process.env.REACT_APP_API_URL}tracking/event/`, {
    event_type: 27,
    tag_name: 'Export JOB to PDF',
    job_id: jobId,
  });

export const getJobActivityFeed = async (jobId: string) => {
  return await axios
    .get(process.env.REACT_APP_API_URL + `jobs/${jobId}/activity-feeds/`)
    .then((res) => res)
    .catch((e) => {
      return e.response;
    });
};

export const getJobExtensionFields = async (jobId: string) => {
  return await axios.get(
    `${process.env.REACT_APP_API_URL}jobs/${jobId}/extension_fields/`,
  );
};

export const createJobExtensionField = async (jobId: string, fieldData: any) => {
  return await axios.post(
    `${process.env.REACT_APP_API_URL}jobs/${jobId}/extension_fields/`,
    fieldData
  );
};

export const updateJobExtensionField = async (jobId: string, fieldId: string, fieldData: any) => {
  return await axios.patch(
    `${process.env.REACT_APP_API_URL}jobs/${jobId}/extension_fields/${fieldId}/`,
    fieldData
  );
};

export const deleteJobExtensionField = async (jobId: string, fieldId: string) => {
  return await axios.delete(
    `${process.env.REACT_APP_API_URL}jobs/${jobId}/extension_fields/${fieldId}/`
  );
};

export const getJobExtensionAnswers = async (jobId: string) => {
  return await axios.get(
    `${process.env.REACT_APP_API_URL}jobs/${jobId}/extension_fields/answers/`
  );
};

export const updateJobExtensionAnswer = async (jobId: string, fieldId: string, value: any) => {
  return await axios.patch(
    `${process.env.REACT_APP_API_URL}jobs/${jobId}/extension_fields/${fieldId}/`,
    { value }
  );
};

export const generateJobInviteLink = async (jobId: string) => {
  // POST request, empty body is fine as per backend docs
  return await axios.post(
    `${process.env.REACT_APP_API_URL}jobs/${jobId}/invite-link/`,
    {},
  );
};

export const validateJobInviteToken = async (jobId: string, token: string) => {
  return await axios.post(
    `${process.env.REACT_APP_API_URL}jobs/${jobId}/invite-link/validate-token/`,
    { token },
  );
};

export const acceptJobInvite = async (
  jobId: string,
  token: string,
  data: { first_name: string; last_name: string; email: string },
) => {
  return await axios.post(
    `${process.env.REACT_APP_API_URL}jobs/${jobId}/invite-accept/`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const createJobActivityFeed = async (jobId: string, message: string) => {
  return await axios.post(
    process.env.REACT_APP_API_URL + `v1/jobs/activity-feeds-create/`,
    { job: jobId, text: message },
  );
};

// Add Job Tag
export const addJobTag = async (jobId: string, tag: string) => {
  // Assuming PATCH request to update tags
  // The backend needs to handle adding the tag to the existing list
  return await axios.patch(
    process.env.REACT_APP_API_URL + `jobs/${jobId}/`,
    { add_tags: [tag] } // Send tag to add in a specific field, e.g., add_tags
  );
};

// Remove Job Tag
export const removeJobTag = async (jobId: string, tag: string) => {
  // Assuming PATCH request to update tags
  // The backend needs to handle removing the tag from the existing list
  return await axios.patch(
    process.env.REACT_APP_API_URL + `jobs/${jobId}/`,
    { remove_tags: [tag] } // Send tag to remove in a specific field, e.g., remove_tags
  );
};

// Update Job Status
export const updateJobStatus = async (jobId: string, status: 'on_hold' | 'published' | 'draft' | 'unpublished' | 'under review' | 'upcoming') => {
  return await axios.patch(
    process.env.REACT_APP_API_URL + `jobs/${jobId}/`,
    { status: status }
  );
};

export const setRecruiterTarget = async ({
  jobId,
  userId,
  targetType,
  targetValue,
}: {
  jobId: string;
  userId: string;
  targetType: string; // 'hires' or 'introductions'
  targetValue: number;
}) => {
  return await axios.post(
    `${api_url}jobs/${jobId}/set-recruiter-target/`,
    {
      user_id: userId,
      target_type: targetType,
      target_value: targetValue,
    }
  );
};

// Define a type for the history entry if not already defined elsewhere
export interface RecruiterTargetHistoryEntry {
  id: string;
  assignment: string; // Assuming assignment ID is returned
  target_type: 'hires' | 'introductions' | null;
  target_value: number | null;
  set_by: {
    id: string;
    name: string;
    role: string;
  } | null;
  created_at: string;
}

export const getRecruiterTargetHistory = async ({
  jobId,
  assignmentId,
}: {
  jobId: string;
  assignmentId: string;
}) => {
  // Adjust the response type based on potential pagination
  // Assuming a paginated response structure similar to others in the app
  // If it's not paginated, adjust accordingly.
  return await axios.get<{ results: RecruiterTargetHistoryEntry[], pagination?: { next: string | null, count: number } }>(
    `${api_url}jobs/${jobId}/recruiter-target-history/?assignment_id=${assignmentId}`
  );
};

export const setRecruiterExtensionPermission = async (jobId: string, userId: string, grant: boolean) => {
  return await axios.post(`${process.env.REACT_APP_API_URL}jobs/${jobId}/set-recruiter-extension-permission/`, {
    user_id: userId,
    grant,
  });
};
